// Auth0 errors that require the user to sign in again (e.g. missing refresh token,
// consent for the API audience, or expired session).
export const isRecoverableAuthError = (error) => {
  const message = String(
    error?.message || error?.error_description || error?.error || ''
  ).toLowerCase();

  return (
    error?.error === 'missing_refresh_token' ||
    error?.error === 'consent_required' ||
    error?.error === 'login_required' ||
    error?.error === 'interaction_required' ||
    message.includes('missing refresh token') ||
    message.includes('missing_refresh_token') ||
    message.includes('consent required') ||
    message.includes('login required')
  );
};

const getAuthReturnTo = () =>
  `${window.location.pathname}${window.location.search}${window.location.hash}`;

export const getLoginRedirectOptions = (returnTo = getAuthReturnTo()) => ({
  appState: { returnTo },
  authorizationParams: {
    redirect_uri: window.location.origin,
  },
});
